class CashUpdate {
	constructor(type, name, amount) {
		this.type = type;
		this.name = name;
		this.amount = amount;
	}

	toPlainObj() {
		return {
			type: this.type,
			name: this.name,
			amount: this.amount,
		};
	}
}

export default function CashUpdateBuilder(){
	return {
		withType: function (type) {
			this.type = type;
			return this;
		},
		withName: function (name) {
			this.name = name;
			return this;
		},
		withAmount: function (amount) {
			this.amount = amount;
			return this;
		},   
		build: function () {
			return new CashUpdate(this.type, this.name, this.amount);
		}
	};
}
